import { EventBus } from "@/utils/bus";
import { USE_PERM_MENU } from "@/config";
import { hasAnyPerm, isPlatformUser } from "@/utils/permission";

/**
 * 页签 / 菜单的权限过滤（RBAC L1）
 * 设计文档：docs/RBAC前端权限显示设计.md §3.6
 *
 * <p>用法：
 * <pre>
 *   import { filterTabs, watchPerm } from "@/utils/tabs";
 *   mounted() {
 *     watchPerm(this, () => { this.systemMenu = filterTabs(TAB_DEFS); });
 *   }
 * </pre>
 * </p>
 *
 * ⚠️ 「宁松勿紧」：开关关闭 / 未配置 perms / 权限未加载 → 一律显示。
 */

/**
 * 按权限过滤页签定义
 * @param {Array<{perms?:string[], platform?:boolean}>} defs
 * @returns {Array} 可见的页签
 */
export function filterTabs(defs) {
  if (!USE_PERM_MENU) {
    return (defs || []).slice();
  }
  return (defs || []).filter((t) => {
    if (t.platform && !isPlatformUser()) return false;
    if (!t.perms || !t.perms.length) return true;
    return hasAnyPerm(t.perms);
  });
}

/**
 * 权限到位后复查一次（解决「组件先渲染、权限后到达」导致菜单被漏过滤）
 * @param {Vue} vm 组件实例（用于自动解绑监听）
 * @param {Function} handler
 */
export function watchPerm(vm, handler) {
  handler();
  const fn = () => handler();
  EventBus.$on("permLoaded", fn);
  if (vm && vm.$once) {
    vm.$once("hook:beforeDestroy", () => {
      EventBus.$off("permLoaded", fn);
    });
  }
}
